import React from 'react';
import { CheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { scrollToPrice } from '../utils/constants';
const BENEFICIOS = ['Ahorrás horas reales de planificación semana a semana', 'Material listo para imprimir y usar (o enviar por PDF)', 'Editable para adaptar a tu curso (Canva/plantillas)', 'Incluye speaking para enganchar adolescentes', 'Incluye evaluaciones + rúbricas + clave de respuestas', 'Funciona para A1–B2 (misma unidad con niveles)'];
export function Beneficios() {
  return <section className="py-20 bg-gray-900 text-white relative overflow-hidden" data-id="element-27">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-orange-900/20 skew-x-12 transform origin-top-right" data-id="element-28"></div>

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-29">
        <div className="text-center mb-16" data-id="element-30">
          <h2 className="text-4xl md:text-5xl font-black text-white uppercase" data-id="element-31">
            Beneficios
          </h2>
          <div className="w-24 h-2 bg-orange-400 mx-auto mt-6 rounded-full" data-id="element-32"></div>
        </div>

        <div className="bg-gray-800/80 backdrop-blur-sm p-8 md:p-12 rounded-3xl border border-gray-700 shadow-2xl" data-id="element-33">
          <ul className="space-y-6" data-id="element-34">
            {BENEFICIOS.map((beneficio, index) => <motion.li initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} key={index} className="flex items-start gap-4" data-id="element-35">
                <div className="bg-orange-500/20 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-36">
                  <CheckIcon className="w-6 h-6 text-orange-400" data-id="element-37" />
                </div>
                <span className="text-xl text-gray-200 font-medium leading-relaxed" data-id="element-38">
                  {beneficio}
                </span>
              </motion.li>)}
          </ul>
        </div>

        <div className="mt-16 text-center" data-id="element-39">
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={scrollToPrice} className="inline-block bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-black text-2xl py-5 px-10 rounded-xl shadow-[0_6px_0_#c2410c] hover:shadow-[0_2px_0_#c2410c] hover:translate-y-[4px] transition-all uppercase tracking-wide" data-id="element-40">
            🚀 ¡QUIERO EMPEZAR HOY!
          </motion.button>
        </div>
      </div>
    </section>;
}